<!-- form-paybright-settings.component.html -->
<mat-card class="configuration-card paybright-settings-card">
  <mat-card-content>
    <form [formGroup]="paybrightSettingsForm" (ngSubmit)="savePaybrightSettings()">
      <mat-progress-spinner
        class="matProgressSpinnerCentered"
        *ngIf="showProgressSpinner"
        mode="indeterminate">
      </mat-progress-spinner>

      <ng-container *ngIf="!showProgressSpinner">

        <!-- Connection status hero, driven by the last credential check -->
        <div class="status-hero" [class.is-disconnected]="verifyOk !== true">
          <div class="status-ring">
            <mat-icon>{{ verifyOk === true ? 'check_circle' : (verifyOk === false ? 'error' : 'help') }}</mat-icon>
          </div>
          <div class="status-text">
            <h2>
              {{ verifyOk === true ? 'Credentials verified'
                 : (verifyOk === false ? 'Not connected' : 'Not yet verified') }}
            </h2>
            <!-- The check only confirms the source key + PIN authenticate; it
                 does NOT confirm a terminal is connected. Only claim terminal
                 readiness when a terminal serial has actually been entered. -->
            <p *ngIf="verifyOk === true && paybrightSettingsForm.get('paybrightTerminalId')?.value">
              Your source key is valid and a terminal serial is configured. You're ready to take card payments.
            </p>
            <p *ngIf="verifyOk === true && !paybrightSettingsForm.get('paybrightTerminalId')?.value">
              Your source key is valid. Add your terminal’s serial number below to take card payments on the terminal.
            </p>
            <p *ngIf="verifyOk === false">{{ verifyMessage || 'We couldn’t verify these details. Double-check your source key and PIN.' }}</p>
            <p *ngIf="verifyOk === null">{{ verifying ? 'Checking your connection…' : 'Enter your details below, then check the connection.' }}</p>
          </div>
          <div class="status-actions">
            <button mat-stroked-button type="button" (click)="verifyCredentials()" [disabled]="verifying">
              <mat-icon>verified_user</mat-icon>
              {{ verifying ? 'Checking…' : 'Verify Credentials' }}
            </button>
          </div>
        </div>

        <!-- Inline error banner -->
        <div class="inline-banner banner-error" *ngIf="errorMessage">
          <mat-icon>error_outline</mat-icon>
          <div class="banner-body">
            <strong>Something went wrong</strong>
            <span>{{ errorMessage }}</span>
          </div>
        </div>

        <app-success-message [message]="successMessage"></app-success-message>

        <!-- Enable toggle -->
        <div class="section enable-section">
          <mat-slide-toggle formControlName="paybrightEnabled" color="primary">
            Enable PayBright for this studio
          </mat-slide-toggle>
        </div>

        <!-- Credentials -->
        <div class="section">
          <div class="section-head">
            <mat-icon class="section-icon">vpn_key</mat-icon>
            <div>
              <h3 class="section-title">Your PayBright details</h3>
              <p class="section-sub">Copy these from your PayBright account. We’ll keep them secure.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Source Key</mat-label>
                <input matInput formControlName="paybrightSourceKey" autocomplete="off"
                       placeholder="Paste your source key">
                <mat-hint>Found in your PayBright account under Source Management.</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>PIN (optional)</mat-label>
                <input matInput type="password" formControlName="paybrightPin" autocomplete="off"
                       placeholder="Leave blank if you don’t have one">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Terminal -->
        <div class="section">
          <div class="section-head">
            <mat-icon class="section-icon">point_of_sale</mat-icon>
            <div>
              <h3 class="section-title">Your terminal</h3>
              <p class="section-sub">The card reader you’ll use to take payments.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Terminal Serial Number</mat-label>
                <input matInput formControlName="paybrightTerminalId" autocomplete="off"
                       placeholder="Printed on the back of your terminal">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Primary action bar -->
        <div class="action-bar">
          <button mat-flat-button color="primary" type="submit">
            <mat-icon>save</mat-icon> Save Settings
          </button>
          <button mat-stroked-button type="button" (click)="registerWebhook()" [disabled]="registeringWebhook">
            <mat-icon>webhook</mat-icon>
            {{ registeringWebhook ? 'Registering…' : 'Register Webhook' }}
          </button>
          <span *ngIf="webhookMessage"
                [ngClass]="{ 'text-success': webhookOk === true, 'text-danger': webhookOk === false, 'text-muted': webhookOk === null }">
            {{ webhookMessage }}
          </span>
          <span class="action-spring"></span>
        </div>

      </ng-container>
    </form>
  </mat-card-content>
</mat-card>
